import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import "./AllowanceModal.css";
import { Grid } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import { useSelector } from "react-redux";
import { createAllowanceUpdate } from "../common/constants/globalconstants";
import ErrorModal from "../common/ErrorModal";
import axiosInstance from "../common/AxiosInterceptor";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "50%",
  padding: "20px !important",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  maxHeight: "80%",
  overflowY: "auto",
  borderRadius:"10px"
};

export default function AllowanceModal(props) {
  const { allowanceFields, setShowMsg, setSuccess, setErrorFlag, setModalOpen, 
    setErrorMsg
   } = props;
  //let navigate = useNavigate();
  //const storetoken = useSelector((state) => state.storetoken);
  const storeuser = useSelector((state) => state.storeuser);
  const [errormodalopen, seterrormodalOpen] = React.useState(false);
  const [allowanceField, setAllowanceField] = React.useState("");

  React.useEffect(() => {
    if (allowanceFields.allowance && allowanceFields.allowance.includes(".")) {
      setAllowanceField(`$` + (allowanceFields.allowance).replace(/^0+(?!\.)/, "") || "0");
    } else {
      setAllowanceField(`$` + (allowanceFields.allowance + ".00").replace(/^0+(?!\.)/, "") || "0");
    }
  }, []);


  const handlesnackbarClick = async () => {
    //let responseSuccessFlag = false;
    //let isErr = false;
    try {
      const inputRequest = createAllowanceUpdateRequest();
        const response = await axiosInstance.post(`${createAllowanceUpdate}`, JSON.stringify(inputRequest));
        if (response.data.isSuccess) {
          //responseSuccessFlag=true;
          setShowMsg(true);
          seterrormodalOpen(false);
          setSuccess(true);
          setErrorFlag(false);
          setModalOpen(true);
        } else if (!response.data.isSuccess) {
          seterrormodalOpen(true);
          setSuccess(false);
        }    
    } catch (error) {
      console.log(error);
      seterrormodalOpen(true);
    }

    props.plzclose(); //close modal
    props.requestindicatordata(true); //open indicator immediately

    setTimeout(() => {
      props.requestsnackbardata(true); //open alert after 7 sec
      props.requestindicatordata(false); //stop indicator
    }, 3000);
  //   if(responseSuccessFlag){
  //   setTimeout(() => {
  //     navigate("/AllowanceListings");
  //   }, 5000);
  // }
  };

  const createAllowanceUpdateRequest = () => {    
    return {
      enrollmentId: allowanceFields.enrollmentId? allowanceFields.enrollmentId : "",
      userName: storeuser.email ? storeuser.email : "",
      achEDate: allowanceFields.picker_date ? allowanceFields.picker_date : "",
      allowanceUpdate: allowanceFields.allowance && allowanceFields.allowance.includes(".")
        ? (allowanceFields.allowance).replace(/^0+(?!\.)/, "") || "0"
        : (allowanceFields.allowance + ".00").replace(/^0+(?!\.)/, "") || "0",
    };
  };

  const [contentsopen, setcontentsOpen] = React.useState(
    allowanceFields.mask_ssn
  );
  const contentopen = () => {
    setcontentsOpen(allowanceFields.SSN || "");
  };

  const contentclose = () => {
    setcontentsOpen(allowanceFields.mask_ssn);
  };

  const [accountsopen, setaccountsOpen] = React.useState(
    allowanceFields.mask_accNum
  );

  const accountopen = () => {
    setaccountsOpen(allowanceFields.accountNum);
  };

  const accountclose = () => {
    setaccountsOpen(allowanceFields.mask_accNum);
  };

  return (
    <div>
      <Modal
        open={props.allowanceModalOpen}
        onClose={props.plzclose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="modalstyle"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h5" component="h2">
            Allowance Verification
            <IconButton
              aria-label="close"
              onClick={props.plzclose}
              sx={{
                position: "absolute",
                right: 35,
                top: 20,
                color: "white",
                backgroundColor: "red",
                padding: "2px",
                boxShadow: "none",
              }}
            >
              <CloseIcon />
            </IconButton>
          </Typography>
          <hr></hr>
          <Box id="details">
            <Grid className="modalcolumnresident">
              <Grid width="50%">
                {" "}
                <Typography id="modal-description-left" sx={{ mt: 2 }}>
                  <Box id="payeename">
                    <strong>First name </strong>
                    <span id="mspan-left">:</span>
                    <span id="modalspan-left">
                      {" "}
                      {allowanceFields.firstName}{" "}
                    </span>
                  </Box>{" "}
                </Typography>
              </Grid>

              <Grid width="50%">
                {" "}
                <Typography id="modal-description-right" sx={{ mt: 2 }}>
                  <Box id="payeename">
                    {" "}
                    <strong>Last name</strong> <span id="mspan-right">:</span>
                    <span id="modalspan-right">{allowanceFields.lastName}</span>
                  </Box>{" "}
                </Typography>
              </Grid>
            </Grid>

            <Grid className="modalcolumnresident">
              <Grid width="50%">
                {" "}
                <Typography id="modal-description-left" sx={{ mt: 2 }}>
                  <Box>
                    <strong>SSN</strong>
                    <span id="mspan-left">:</span>
                    <span id="modalspan-left">
                      <Tooltip
                        id="tooltip"
                        onOpen={contentopen}
                        onClose={contentclose}
                        title="  "
                        placement="left-start"
                      >
                        <IconButton id="iconbutton">{contentsopen}</IconButton>
                      </Tooltip>
                    </span>{" "}
                  </Box>{" "}
                </Typography>
              </Grid>

              <Grid width="50%">
                {" "}
                <Typography id="modal-description-right" sx={{ mt: 2 }}>
                  <Box>
                    {" "}
                    <strong>A/C No.</strong> <span id="mspan-right">:</span>
                    <span id="modalspan-right">
                      <Tooltip
                        id="tooltip"
                        onOpen={accountopen}
                        onClose={accountclose}
                        title="  "
                        placement="right-start"
                      >
                        <IconButton id="iconbutton">{accountsopen}</IconButton>
                      </Tooltip>
                    </span>{" "}
                  </Box>{" "}
                </Typography>
              </Grid>
            </Grid>

            <Grid className="modalcolumnresident">
              <Grid width="50%">
                {" "}
                <Typography id="modal-description-left" sx={{ mt: 2 }}>
                  <Box>
                    <strong>Telephone No</strong>
                    <span id="mspan-left">:</span>
                    <span id="modalspan-left">
                      {" "}
                      {allowanceFields.tele_number}{" "}
                    </span>
                  </Box>{" "}
                </Typography>
              </Grid>

              <Grid width="50%">
                {" "}
                <Typography id="modal-description-right" sx={{ mt: 2 }}>
                  <Box>
                    {" "}
                    <strong>Point Of Contact</strong>{" "}
                    <span id="mspan-right">:</span>
                    <span id="modalspan-right">{allowanceFields.contact}</span>
                  </Box>{" "}
                </Typography>
              </Grid>
            </Grid>

            <Grid className="modalcolumnresident">
              <Grid item xs={12}>
                {" "}
                <Typography id="modal-description-left" sx={{ mt: 2 }}>
                  <Box>
                    <strong> Address-Street </strong>
                    <span id="mspan-left">:</span>
                    <span id="modalspan-left">
                      {allowanceFields.address.street}
                    </span>
                  </Box>{" "}
                </Typography>
              </Grid>
            </Grid>

            <Grid className="modalcolumnresident">
              <Grid width="50%">
                {" "}
                <Typography id="modal-description-left" sx={{ mt: 2 }}>
                  <Box>
                    <strong> City </strong>
                    <span id="mspan-left">:</span>
                    <span id="modalspan-left">
                      {allowanceFields.address.city}
                    </span>
                  </Box>{" "}
                </Typography>
              </Grid>

              <Grid width="50%">
                {" "}
                <Typography id="modal-description-right" sx={{ mt: 2 }}>
                  <Box>
                    <strong> State </strong>
                    <span id="mspan-right">:</span>
                    <span id="modalspan-right">
                      {" "}
                      {allowanceFields.address.state}{" "}
                    </span>
                  </Box>{" "}
                </Typography>
              </Grid>
            </Grid>

            <Grid className="modalcolumnresident">
              <Grid width="50%">
                {" "}
                <Typography id="modal-description-left" sx={{ mt: 2 }}>
                  <Box>
                    {" "}
                    <strong>Zip Code</strong> <span id="mspan-left">:</span>
                    <span id="modalspan-left">
                      {allowanceFields.address.zip_code}
                    </span>
                  </Box>{" "}
                </Typography>
              </Grid>

              <Grid width="50%">
                {" "}
                <Typography id="modal-description-right" sx={{ mt: 2 }}>
                  <Box>
                    {" "}
                    <strong>Allowance</strong> <span id="mspan-right">:</span>
                    <span id="modalspan-right">
                      {allowanceField
                        ? allowanceField
                        : (allowanceFields.allowance).replace(/^0+(?!\.)/, "") || "0"}
                    </span>
                  </Box>{" "}
                </Typography>
              </Grid>
            </Grid>

            <Grid className="modalcolumnresident">
              <Grid width="50%">
                {" "}
                <Typography id="modal-description-left" sx={{ mt: 2 }}>
                  <Box id="allowanceDate">
                    <strong>Allowance Date </strong>{" "}
                    <span id="mspan-left">:</span>
                    <span id="modalspan-left">
                      {" "}
                      {allowanceFields.picker_date}{" "}
                    </span>
                  </Box>{" "}
                </Typography>
              </Grid>
            </Grid>

            <hr></hr>
          </Box>

          <br></br>
          <Box>
            <strong>
              <span id="submit">Do you want to submit this information?</span>
            </strong>
            <Button
              id="btn1"
              variant="contained"
              href="#AllowanceListings"
              onClick={handlesnackbarClick}
              type="submit"
            >
              Yes
            </Button>

            <Button
              color="error"
              id="btn2"
              variant="outlined"
              href="#outlined-buttons"
              onClick={props.plzclose}
            >
              No
            </Button>
          </Box>
        </Box>
      </Modal>
      {errormodalopen?
      <ErrorModal plzopen={true} onClose={() => seterrormodalOpen(false)} />
      :""}
    </div>
  );
}
